import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class MarkAsReviewedService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following AngularJS markAsReviewedServiceFactory.markAsReviewed pattern exactly
  markAsReviewed(
    baseUrl: string,
    returnClobSettingsObj: any,
    ecSaveDtls: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action code exactly like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=9k1t9p`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure exactly like AngularJS service
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Build clob_settings from returnClobSettingsObj exactly like AngularJS
    const clobSettings: any = {
      tax_year: returnClobSettingsObj?.tax_year || filterParams?.tax_year || '',
      scenario: returnClobSettingsObj?.scenario || filterParams?.scenario || '',
      jcd_key: returnClobSettingsObj?.jcd_key || filterParams?.jcd_key || globalService?.globalParams?.jcd_key || '',
      sso_id: returnClobSettingsObj?.sso_id || globalService?.globalParams?.sso_id || ''
    };
    
    // Build JSON objects exactly like AngularJS service
    const jsonObj = JSON.stringify(ecSaveDtls || []);
    const jsonSettings = JSON.stringify(clobSettings);
    
    // Extend with clob_data and clob_settings exactly like AngularJS
    params = _.extend({ clob_settings: jsonSettings }, params);
    params = _.extend({ clob_data: jsonObj }, params);
    
    // 🚀 CRITICAL: Add required configuration parameters with proper fallbacks
    params.tax_year = filterParams?.tax_year || returnClobSettingsObj?.tax_year || globalService?.globalParams?.tax_year || new Date().getFullYear();
    params.scenario = filterParams?.scenario || returnClobSettingsObj?.scenario || globalService?.globalParams?.scenario || 74;
    params.jcd_key = globalService?.globalParams?.jcd_key || returnClobSettingsObj?.jcd_key || filterParams?.jcd_key || 250;
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.globalParams?.scenarioCode || globalService?.globalParams?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.sso_id = returnClobSettingsObj?.sso_id || globalService?.globalParams?.sso_id || '';
    params.process_name = "Mark Partnerships As Reviewed";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // 🚀 CRITICAL: Following AngularJS fetchMaxCountEntities pattern exactly
  fetchMaxCountEntities(
    baseUrl: string,
    params: any
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction exactly like AngularJS
    const url = `${baseUrl}/loadJsonObject`;

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
